import supportsIntersectionObserver from 'lib/supportsIntersectionObserver';
import { useEffect } from 'react';

export const useInViewCallback = (ref, callback, rootMargin = '-10%') => {
  useEffect(() => {
    const refCurrent = ref.current;

    if (!supportsIntersectionObserver()) return () => {};

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) callback();
      },
      {
        rootMargin,
      }
    );

    if (ref.current) observer.observe(refCurrent);

    return () => {
      if (refCurrent) observer.unobserve(refCurrent);
    };
  }, [callback, ref, rootMargin]);
};

export default useInViewCallback;
